import { createActions, createReducer } from 'reduxsauce'
import labels from '../components/Filtro/Labels'

const meses = [
    { value: '1', label: labels['janeiro'] },
    { value: '2', label: labels['fevereiro'] },
    { value: '3', label: labels['marco'] },
    { value: '4', label: labels['abril'] },
    { value: '5', label: labels['maio'] },
    { value: '6', label: labels['junho'] },
    { value: '7', label: labels['julho'] },
    { value: '8', label: labels['agosto'] },
    { value: '9', label: labels['setembro'] },
    { value: '10', label: labels['outubro'] },
    { value: '11', label: labels['novembro'] },
    { value: '12', label: labels['dezembro'] },
]

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setExercicioOperacoesDespesas: ['exercicio'],
    setMesOperacoesDespesas: ['mes'],
    setAdministracoesOperacoesDespesas: ['administracoes'],
    setRecursosOperacoesDespesas: ['recursos'],
    setDestinacoesOperacoesDespesas: ['destinacoes'],
    setTipoRecursosOperacoesDespesas: ['tipoRecursos'],
    setSequenciaOperacoesDespesas: ['sequencia'],
    limpaFiltroOperacoesDespesas: [],
    receberFiltroOperacoesDespesas: ['filtroRecebido'],
})

const INITIAL_STATE = {
    exercicio: { value: new Date().getFullYear(), label: new Date().getFullYear() },
    mes: { value: (new Date().getMonth() + 1).toString(), label: meses[new Date().getMonth()].label },
    administracoes: [],
    recursos: [],
    destinacoes: [],
    tipoRecursos: [],
    sequencia: [],
}

const setExercicio = (state = INITIAL_STATE, action) => {
    return { ...state, exercicio: action.exercicio }
}

const setMes = (state = INITIAL_STATE, action) => {
    return { ...state, mes: action.mes }
}

const setAdministracoes = (state = INITIAL_STATE, action) => {
    return { ...state, administracoes: action.administracoes }
}

const setRecursos = (state = INITIAL_STATE, action) => {
    return { ...state, recursos: action.recursos }
}

const setDestinacoes = (state = INITIAL_STATE, action) => {
    return { ...state, destinacoes: action.destinacoes }
}

const setTipoRecursos = (state = INITIAL_STATE, action) => {
    return { ...state, tipoRecursos: action.tipoRecursos }
}

const setSequencia = (state = INITIAL_STATE, action) => {
    return { ...state, sequencia: action.sequencia }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    //Nunca deve apagar a sequencia, pois ela
    //é atribuida só na inicializacao do programa
    return { ...INITIAL_STATE, sequencia: state.sequencia }
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_EXERCICIO_OPERACOES_DESPESAS]: setExercicio,
    [Types.SET_MES_OPERACOES_DESPESAS]: setMes,
    [Types.SET_ADMINISTRACOES_OPERACOES_DESPESAS]: setAdministracoes,
    [Types.SET_RECURSOS_OPERACOES_DESPESAS]: setRecursos,
    [Types.SET_DESTINACOES_OPERACOES_DESPESAS]: setDestinacoes,
    [Types.SET_TIPO_RECURSOS_OPERACOES_DESPESAS]: setTipoRecursos,
    [Types.SET_SEQUENCIA_OPERACOES_DESPESAS]: setSequencia,
    [Types.LIMPA_FILTRO_OPERACOES_DESPESAS]: limpaFiltro,
    [Types.RECEBER_FILTRO_OPERACOES_DESPESAS]: receberFiltro,
})
